import { MortgageTerms } from '../../api/httpHandlers'
import { InputFieldsState } from './DebouncedInputs'

export function validateFields(inputFieldsState: InputFieldsState, mortgageTerms: MortgageTerms) {
  const { estimatedValue, mortgage, wantedLoanAmount } = inputFieldsState
  const {
    minHousePrice,
    maxLoanAmountMortgage,
    minLoanAmountMortgage,
    maxLoanToValueRatioMortgage,
  } = mortgageTerms

  function validateEstimatedValue() {
    if (estimatedValue.hasBeenTouched && estimatedValue.value < minHousePrice) {
      estimatedValue.error = `Bostadens värde måste vara minst ${minHousePrice.toLocaleString('sv-SE')} kr.`
    } else if (estimatedValue.hasBeenTouched && estimatedValue.value > 100_000_000) {
      estimatedValue.error = `Välj ett bostadspris på max 100 miljoner kr.`
    } else {
      estimatedValue.error = ''
    }
  }

  function validateMortgage() {
    if (mortgage.hasBeenTouched) {
      const mortgageAmount = mortgage.value
      if (mortgageAmount > maxLoanAmountMortgage) {
        mortgage.error = `Lånebeloppet får inte vara mer än ${maxLoanAmountMortgage.toLocaleString('sv-SE')} kr.`
      } else if (mortgageAmount < minLoanAmountMortgage) {
        mortgage.error = `Lånebeloppet får inte vara mindre än ${minLoanAmountMortgage.toLocaleString('sv-SE')}\u00A0kr.`
      } else if (
        (mortgageAmount + wantedLoanAmount.value) / estimatedValue.value >
        maxLoanToValueRatioMortgage
      ) {
        mortgage.error = `Det totala bolånet får inte överstiga ${maxLoanToValueRatioMortgage * 100}\u00A0% av bostadens värde.`
      } else {
        mortgage.error = ''
      }
    }
  }

  function validateWantedLoanAmount() {
    if (wantedLoanAmount.hasBeenTouched && wantedLoanAmount.value <= 0) {
      wantedLoanAmount.error = 'Fyll i önskat lånebelopp.'
    } else if (
      wantedLoanAmount.hasBeenTouched &&
      wantedLoanAmount.value < 50_000 &&
      wantedLoanAmount.value > 0
    ) {
      wantedLoanAmount.error =
        'Beloppet är för lågt. Lägsta belopp att låna är 50\u00A0000\u00A0kr.'
    } else if (
      (mortgage.value + wantedLoanAmount.value) / estimatedValue.value >
      maxLoanToValueRatioMortgage
    ) {
      wantedLoanAmount.error = `Det totala bolånet får inte överstiga ${maxLoanToValueRatioMortgage * 100}\u00A0% av bostadens värde.`
    } else {
      wantedLoanAmount.error = ''
    }
  }

  validateEstimatedValue()
  validateMortgage()
  validateWantedLoanAmount()

  const fieldsAreValid = Object.values({ estimatedValue, mortgage, wantedLoanAmount }).every(
    (field) => field.error === '' && field.hasBeenTouched === true,
  )

  return { estimatedValue, mortgage, wantedLoanAmount, fieldsAreValid }
}
